import Base from './Base';

export interface ApiAuthorsResponse extends ApiListResponse<Author> {
    letters: {
        [letter: string]: number;
    };
}

class Authors extends Base {
    get(query = null, page = null, count = null, opts = null) {
        return this.getJSON<ApiAuthorsResponse>(
            '/authors',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        );
    }

    findBySlug(slug: string, opts = null): Promise<Author | null> {
        return this.getJSON<Author | null>(
            '/authors',
            {
                uri: slug,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }

    findByHandle(handle: string, opts = null): Promise<Author | null> {
        return this.getJSON<Author | null>(
            '/authors',
            {
                handle,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }
}

export default Authors;
